"use strict";

module.exports = function () {
  var defaults = require('../config/defaults')();

  return this.initOptions(defaults, this.globalOptions, this.options);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/opts.js
// module id = 1563
// module chunks = 64